import React, { useState,useEffect, useRef } from 'react';
import { FiBell, FiCalendar } from 'react-icons/fi';
import { mockProfilerProfile } from '../../../data/mockProfilerProfile';
import MphLogo from '../../../assets/MphLogo.png';
import profilerLogo from '../../../assets/RecruiterLogo.png';
import { Link, useLocation } from 'react-router-dom';
import unifiedAuthManager from '../../../services/unifiedAuthManager'
import { useNavigate } from 'react-router-dom';
import RadialProgressAvatar from '../jobsRecommendationPage/radialProgressAvatar';
import Sidebar from '../jobsRecommendationPage/sideBar';
import { FiUploadCloud, FiUpload } from 'react-icons/fi';
import { Trash } from "lucide-react";
import {resumeUpload} from '../../../supports/resumeUpload';
import { useToast } from '../../../common/toastSystem';

const navLinks = [
    // { name: 'Home', path: '/job-recommendations' },
    // { name: 'Opportunities', path: '/opportunities' },
    // { name: 'Invites', path: '/invites' },
];

const ProfilerNavbar = ({ status, profileDetails,userData,userCandidateId ,completionPercentage,handleViewAndUpdateResume}) => {
    const location = useLocation();
      const navigate = useNavigate();
      const [showSignout,setShowSignout]=useState(false)
      const profileRef =useRef(null)
      const [isDelete,setIsDelete]=useState(false)  
        const toast = useToast();
          const isAuthed = unifiedAuthManager.isAuthenticated();
    
    useEffect(()=>{
     console.log('pro details',profileDetails)
    },[profileDetails])

        useEffect(() => {
          function handleClickOutside(event) {
            // If click is outside the profile area and not on the signout button, close dropdown
            if (
              profileRef.current &&
              !profileRef.current.contains(event.target)
            ) {
              setShowSignout(false);
            }
          }
          if (showSignout) {
            document.addEventListener('mousedown', handleClickOutside);
          } else {
            document.removeEventListener('mousedown', handleClickOutside);
          }
          return () => {
            document.removeEventListener('mousedown', handleClickOutside);
          };
        }, [showSignout]);

     const handleSignout = (e) => {
    e.preventDefault();
    e.stopPropagation();
    // setShowSignout(false);
    unifiedAuthManager.clearAll?.(); 
    navigate('/resume-login');
  };

  const handleDeleteProfile=async()=>{
    try {
      if(userCandidateId){    
        const res= await  resumeUpload.deleteCandidate?.(userCandidateId)
        setIsDelete(false);
        console.log('delete response',res)            
        if(res?.status_code===204){
          toast.success('Profile deleted successfully');
          unifiedAuthManager.clearAll?.(); 
          navigate('/resume-login');
        } 
        else if(res?.status_code===400){
          toast.warning(res?.message || 'Unable to delete profile at the moment');
        }


      } 
    } catch (error) {
      console.log('error deleting candidate',error)
    } 
  } 

  const SignOutSvg = () => (
  <svg
    width="15"
    height="15"
    viewBox="0 0 24 24"
    fill="none"
    style={{ display: 'inline', verticalAlign: 'middle', marginRight: '8px' }}
    xmlns="http://www.w3.org/2000/svg"
  >
    <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
    <g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round"></g>
    <g id="SVGRepo_iconCarrier">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M21.593 10.943c.584.585.584 1.53 0 2.116L18.71 15.95c-.39.39-1.03.39-1.42 0a.996.996 0 0 1 0-1.41 9.552 9.552 0 0 1 1.689-1.345l.387-.242-.207-.206a10 10 0 0 1-2.24.254H8.998a1 1 0 1 1 0-2h7.921a10 10 0 0 1 2.24.254l.207-.206-.386-.241a9.562 9.562 0 0 1-1.69-1.348.996.996 0 0 1 0-1.41c.39-.39 1.03-.39 1.42 0l2.883 2.893zM14 16a1 1 0 0 0-1 1v1.5a.5.5 0 0 1-.5.5h-7a.5.5 0 0 1-.5-.5v-13a.5.5 0 0 1 .5-.5h7a.5.5 0 0 1 .5.5v1.505a1 1 0 1 0 2 0V5.5A2.5 2.5 0 0 0 12.5 3h-7A2.5 2.5 0 0 0 3 5.5v13A2.5 2.5 0 0 0 5.5 21h7a2.5 2.5 0 0 0 2.5-2.5V17a1 1 0 0 0-1-1z"
        fill="#004645"
      ></path>
    </g>
  </svg>
);

    // Only show logos if status is not 'success'
    if (status !== 'success') {
        return (
            <nav className=" top-0 left-0 w-full z-50 nav-bar-bg py-4 px-8">
                <div className="flex items-center gap-4">
                    <img src={MphLogo} alt="MPH Logo" className="h-12" />
                    <img src={profilerLogo} alt="MPH" className="w-16 mb-2" />
                </div>
            </nav>
        );
    }

    return (
          <nav className="fixed top-0 left-0 w-full z-50 nav-bar-bg py-4 px-4 md:px-8">
      <div className="flex justify-between items-center w-full">
        {/* Logo Section */}
        <div className="flex items-center gap-2 md:gap-4">
          <img src={MphLogo} alt="MPH Logo" className="h-8 md:h-12" />
          <img src={profilerLogo} alt="MPH" className="w-12 md:w-16" />
        </div>

        {/* Desktop Navigation Links */}
        <ul className="hidden lg:flex items-center gap-8 text-gray-600 font-semibold">
          {navLinks.map(link => (
            <li key={link.name}>
              <Link
                to={link.path}
                className={`
                  ${location.pathname === link.path
                    ? 'mph-primary pb-1 border-b-2 border-current'
                    : 'hover:mph-primary'
                  }
                `}
              >
                {link.name}
              </Link>
            </li>
          ))}
        </ul>

        {/* Desktop Profile Section */}
        <div className="flex items-center gap-4">
          <div className="hidden md:flex flex-col ml-2 text-right">
            <span className="font-bold mph-primary text-sm lg:text-base">
              {profileDetails?.first_name} {profileDetails?.last_name || ''}
            </span>
            <span className="text-xs text-gray-500">
              {profileDetails?.email || ''}
            </span>
          </div>
          <div 
            onClick={() => setShowSignout(true)} 
            className="md:w-12 md:h-12 w-10 h-10  transform md:scale-[1] scale-[0.8]  cursor-pointer rounded-full bg-gray-100 flex items-center justify-center mph-primary font-bold text-lg shadow-md relative"
          >
            <RadialProgressAvatar
              completion={completionPercentage}
              size='50'
              firstName={profileDetails.first_name}
              lastName={profileDetails.last_name}
              ispercentage={false}
            />

                        {showSignout && (
              <div ref={profileRef}
                className="absolute right-[2rem] top-[4.5rem] bg-white border border-gray-200 rounded-lg shadow-lg p-4 min-w-[155px] z-50  "
                style={{ minWidth: '155px' }}
              >
                <Sidebar
          profileDetails={profileDetails}
          showActivity={userData.isCandidateExist}
          onViewAndUpdateResume={handleViewAndUpdateResume}
          completionPercentage={completionPercentage}
        />  
        {isAuthed &&(
          <div className='flex flex-col  '>
            <button
                  title='  Delete Profile'
                  className="w-full text-left text-red-400  text-xs font-semibold py-1 px-2 rounded transition-colors flex items-center hover:bg-gray-100"
                  type="button"
                  onMouseDown={()=>setIsDelete(true)}
                >
                  <Trash size={14} className="mr-2" />
                  Delete Profile
                </button>
                <button
                  title='Sign out'
                  className="w-full text-left mph-primary  text-xs font-semibold py-1 px-2 rounded transition-colors flex items-center hover:bg-gray-100"
                  type="button"
                  onMouseDown={handleSignout}
                >
                  <SignOutSvg />
                  Sign out
                </button>
                </div>
                )}
                  {!userCandidateId &&(
                <button
                  title='Upload resume'
                  className="w-full text-left mph-primary gap-2 text-xs font-semibold py-1 px-2 rounded transition-colors flex items-center hover:bg-gray-100"
                  type="button"
                  onClick={()=>navigate('/profiler')}
                >
                       <FiUpload size={16} />    Upload resume 
                </button>
                )}
              </div>
            )}
                    </div>
                </div>
            </div>
            {isDelete && (
               <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4 z-50">
         
         <div className="bg-white transform scale-[0.8] 2xl:scale-100 xl:scale-100 md:scale-100 sm:scale-[0.9]  rounded-lg shadow-xl w-full max-w-sm mx-4 ">
              <div className="w-full px-4 flex items-center gap-3 py-3 border-b border-gray-100">
              <div className="flex items-center justify-center w-8 h-8 rounded-full bg-red-50">
                <svg 
                  className="w-5 h-5 text-red-500" 
                  fill="none" 
                  stroke="currentColor" 
                  viewBox="0 0 24 24"
                >
                  <path 
                    strokeLinecap="round" 
                    strokeLinejoin="round" 
                    strokeWidth={2} 
                    d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z" 
                  />
                </svg>
              </div>
              <h3 className="text-base font-semibold text-zinc-800">Delete Profile</h3>
            </div>
            <div className='text-xs w-full  px-4 py-4 border-b '>
              <p className='p-2 font-semibold text-gray-600 leading-relaxed'>Deleting your account is permanent. All your data, including job applications, will be removed and could affect future job opportunities. Do you want to proceed?
            </p>
            </div>
             
            <div className="flex flex-col bg-gray-50 rounded-b-lg sm:flex-row py-3 px-4 gap-2">
              <button
                onClick={() => (setIsDelete(false), setShowSignout(false))}
                className="md:ml-auto sm:ml-auto  px-3 py-1.5 text-xs bg-gray-200 text-gray-700 rounded-full hover:bg-gray-300 transition-colors font-medium"
              >
                Cancel
              </button>
              <button
                onClick={handleDeleteProfile}
                className=" px-3 py-1.5 text-xs bg-[#B2853D] text-white rounded-full hover:opacity-70 transition-colors font-medium"
              >
                Delete
              </button>
            </div>
            {/* SVG Icon */}
            {/* <div className="flex justify-center mb-4">
              <svg 
                className="w-12 h-12  text-[#004645]" 
                fill="none" 
                stroke="currentColor" 
                viewBox="0 0 24 24"
              >
                <path 
                  strokeLinecap="round" 
                  strokeLinejoin="round" 
                  strokeWidth={2} 
                  d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z" 
                />
              </svg>
            </div>

            <h2 className="text-xl  font-bold text-[#004645] text-center mb-3">
              Delete Profile?
            </h2>
            
            <p className="text-xs text-gray-600 text-center mb-6 sm:mb-8">
             This action cannot be undone. Deleting your account will permanently delete your data and job applications.
            </p>

            <div className="flex flex-col sm:flex-row gap-3">
              <button
                onClick={() => (setIsDelete(false), setShowSignout(false))}
                className="w-full p-2 text-sm bg-gray-200 text-gray-700 rounded-lg hover:bg-gray-300 transition-colors font-medium"
              >
                Cancel
              </button>
              <button
                onClick={handleDeleteProfile}
                className="w-full p-2 text-sm bg-[#004645] text-white rounded-lg hover:opacity-70 transition-colors font-medium"
              >
                Delete
              </button>
            </div> */}
          </div>
        </div>
            )}
        </nav>
    );
};
export default ProfilerNavbar;